import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { AUTH_UNIVERSITY } from "../utils/config";

function AdminProtectedRoute({ children }) {
  const { isAuthenticated, user, restoreAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(
    function () {
      const getUserData = localStorage.getItem("userData");
      let jsonUser = null;
      if (getUserData != null) {
        jsonUser = JSON.parse(getUserData);
      }
      let result = false;
      const isRestored = restoreAuth();
      if (isRestored) {
        if ("is_admin" in user) {
          if (isAuthenticated && user.is_admin) {
            result = true;
          }
        } else {
          // F5画面更新操作など
          // localStorageの情報を確認
          if (jsonUser != null && jsonUser["is_admin"]) {
            result = true;
          }
        }
      }
      if (!result) {
        // localStorageの情報も含めて認証エラーの場合
        document.location = "/admin/login";
      }
      // 大学権限の場合は講座以外のアクセスをブロック(システムエラー)
      const paths = document.location.pathname.split("/");
      const level2Route = paths.length > 1 ? paths[2] : "";
      switch (level2Route) {
        case "student":
        case "admin":
        case "notification":
          if ("authority" in user && user.authority === AUTH_UNIVERSITY) {
            navigate("/admin/apierror");
          } else if (
            jsonUser != null &&
            jsonUser["authority"] == AUTH_UNIVERSITY
          ) {
            navigate("/admin/apierror");
          }
          break;
        default:
          break;
      }
    },
    [isAuthenticated, navigate, user]
  );

  return isAuthenticated ? children : null;
}

function MyPageProtectedRoute({ children }) {
  const { isAuthenticated, user, restoreAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(
    function () {
      let result = false;
      const isRestored = restoreAuth();
      if (isRestored) {
        if ("is_admin" in user) {
          if (isAuthenticated && !user.is_admin) {
            result = true;
          }
        } else {
          // F5画面更新操作など
          // localStorageの情報を確認
          const getUserData = localStorage.getItem("userData");
          if (getUserData != null) {
            const jsonUser = JSON.parse(getUserData);
            if (!jsonUser["is_admin"]) {
              result = true;
            }
          }
        }
      }
      if (!result) {
        // localStorageに遷移しようとしたURLを格納
        let locationHref =
          typeof document.location.href === "string"
            ? document.location.href
            : null;
        let loginUrl = "/mypage/login";
        const origin = window.location.origin;
        if (locationHref !== null && locationHref.startsWith(origin)) {
          // 遷移先がシブカツサイト内のページである場合、/mypage始まりにする
          locationHref = document.location.pathname;
          if (
            !(
              locationHref.startsWith(loginUrl) ||
              /^\/mypage\/?$/.test(locationHref)
            )
          ) {
            // ログイン画面のURLでも/mypageでもない場合、リクエストパラメータの末尾に追加
            loginUrl += "?next=" + locationHref;
          }
        }

        // ログイン画面に遷移
        document.location = loginUrl;
      }
    },
    [isAuthenticated, navigate, user]
  );

  return isAuthenticated ? children : null;
}

export { AdminProtectedRoute, MyPageProtectedRoute };
